import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Stage} from 'vexpo-components';

/** @class StageDisplay
  * A class for displaying a stage.  Basically, it converts
  * the editor representation of layers to the client
  * one (an Array instead of an Object)
  * @param {Object} layers - the layers object to convert to an array
  * @param {number} width - the width of the stage in pixels
  * @param {number} height - the height of the stage in pixels
  */
export default class StageDisplay extends Component {
  /** @method render
    * Renders the component.
    */
  render() {
    var layers = [];
    for(var key in this.props.layers) {
      var layer = this.props.layers[key];
      layer.id = key;
      layers.push(layer);
    }
    layers = layers.sort((a,b) => a.order - b.order);
    return (
      <div className="stage-wrapper">
        <Stage {...this.props} layers={layers}/>
      </div>
    )
  }
}

StageDisplay.propTypes = {
  layers: PropTypes.object.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired
}



// WEBPACK FOOTER //
// ./src/stage-editor/stage-display.js